export const SET_LOADING = 'SET_LOADING'
export const SET_CENTERED = 'SET_CENTERED'
export const SET_DARK_MODE = 'SET_DARK_MODE'
export const SET_LATEST_VERSION = 'SET_LATEST_VERSION'
